import UserAPI from '../api/users';

export const user = {
    state: {
        user: null,
        userLoadStatus: 0,
        userUpdateStatus: 0
    },

    actions: {
        setUser({commit, state}, user) {
            return new Promise((resolve, reject) => {
                if (user && user.email) {
                    console.log('Set User', user.email);
                } else {
                    console.log('Set User', 'Null');
                }
                commit('setUser', user);
                commit('setUserLoadStatus', 2);

                return resolve(user);
            })
        },

        loadUser({commit, state}) {
            return new Promise((resolve, reject) => {
                commit('setUserLoadStatus', 1);

                /* If user is empty, see if it was sent in with the app load, if so use that one */
                if (!state.user && window.Laravel.user) {
                    commit('setUser', window.Laravel.user);
                    commit('setUserLoadStatus', 2);
                    console.log('User Set From JS object');

                    return resolve(window.Laravel.user);
                }

                UserAPI.getLoggedInUser()
                    .then(function (response) {
                        commit('setUser', response.data);
                        commit('setUserLoadStatus', 2);
                        console.log('User Set From Axios Load');

                        return resolve(response.data);
                    })
                    .catch(function () {
                        commit('setUser', null);
                        commit('setUserLoadStatus', 3);
                        console.log('User Failed to  Load');

                        return resolve();
                    });
            })
        }
    },

    mutations: {
        setUserLoadStatus(state, status) {
            state.userLoadStatus = status;
        },

        setUser(state, user) {
            state.user = user;
        }
    },

    getters: {
        getUserLoadStatus(state) {
            return state.userLoadStatus;
        },

        getUser(state) {
            return state.user;
        }
    }
}
